/** Espelho de tipo_distribuidor (Pessoa). 0 = token antigo, tratar como Distribuidor. */
export enum TipoDistribuidorEnum {
  EasyERP = 1,
  Master = 2,
  Distribuidor = 3,
  Interno = 4,
}
